export default __webpack_public_path__ + "static/media/iphone.6855a4ec.png";